import React from 'react';
import { required } from 'react-admin';

import { Grid } from '@mui/material';

import requestEntityFields from '../../../../constants/requestEntityFields';
import requestTypes from '../../../../constants/requestTypes';
import ReferenceEntityInputV2 from '../../../../customFields/ReferenceEntityInputV2';
import requestRolesChoices from '../../../../constants/requestRoles';

const CarKyc = () => (
  <Grid container spacing={6}>
    {requestEntityFields[requestTypes.CAR_KYC.id].map((role) => (
      <Grid
        display="flex"
        key={role}
        size={12}
      >
        <ReferenceEntityInputV2
          key={role}
          label={requestRolesChoices[role].name}
          source={`extraInformation.${role}`}
          validate={[required()]}
        />
      </Grid>
    ))}
  </Grid>
);

export default CarKyc;
